import type { AppBundleIdOptionPayload } from '@openx/types/targeting/inventoryAndContent.ts';
import { ComparisonType, Criteria } from '@openx/types/targeting/targetingValuesTypes.ts';
import type { TFunction } from 'i18next';

export type GetAlertTooltipText = {
  t: TFunction;
  comparisonType: ComparisonType;
  inventoryContent: AppBundleIdOptionPayload;
};

export const getAlertTooltipConfig = ({ t, comparisonType, inventoryContent }: GetAlertTooltipText) => {
  const { op, val } = inventoryContent;

  const hasSelectedRestrictedOptions =
    val &&
    Object.keys(val).some(
      item => item === ComparisonType.DOES_NOT_EQUAL || item === ComparisonType.DOES_NOT_BEGIN_WITH
    );

  const isInvalidComparisonType =
    comparisonType === ComparisonType.DOES_NOT_BEGIN_WITH || comparisonType === ComparisonType.DOES_NOT_EQUAL;
  const isInvalidOp = op === Criteria.ALL;

  if (!isInvalidComparisonType && !isInvalidOp && !hasSelectedRestrictedOptions) {
    return { shouldDisplayAlert: false, message: '' };
  }

  const messages: string[] = [];

  if (isInvalidComparisonType || hasSelectedRestrictedOptions) {
    messages.push(t('To select Inventory List please select ‘Equals’ criteria.'));
  }

  if (isInvalidOp) {
    messages.push(t('In order to select Inventory List please choose "Any" criteria.'));
  }

  return {
    shouldDisplayAlert: true,
    message: messages.join(' '),
  };
};
